/**
 * 通信系のutil
 * ※複数順不同の場合 promise all
 */
import axios from 'axios';
import Constants from '../constants';

const axiosUtil = {
    // アクセスカウンター
    async count() {
        try {
            const count = await axiosUtil.getInternalApi(Constants.API.COUNT);
            return count;
        } catch (e) {
            return 0;
        }
    },
    
    /**
     * 内部API get
     */
    getInternalApi(url) {
        if (axiosUtil.isLocalhost()) { return new Promise((resolve, reject) => { reject(); }); }
        return axios.get(Constants.API.BASE_URL + url).then((res) => {
            return res.data;
        }).catch((e) => {
            console.log(e)
            // スルー
        });
    },
    /**
     * 外部API get
     */
    getExternalApi(url) {
        return axios.get(url).then((res) => {
            return res.data;
        }).catch((e) => {
            console.log(e)
            // スルー
        });
    },
    // ローカルホストで実行中か？
    isLocalhost () {
        return location.hostname === "localhost" ||
            location.hostname === "127.0.0.1";
    },
};

export default axiosUtil;